export * from './charge.service';


// WEBPACK FOOTER //
// ./src/app/infrastructure/services/master/om/index.ts